import React from "react";
import CurrencyInputBase from "react-currency-input-field";
import { CurrencyInputProps } from "react-currency-input-field/dist/components/CurrencyInputProps";
import cn from "classnames";

const CurrencyInput = ({
  className,
  disabled,
  error,
  ...props
}: CurrencyInputProps & { error?: boolean }) => {
  return (
    <CurrencyInputBase
      disabled={disabled}
      className={cn(
        "border border-solid border-gray-300 focus:border-primary text-base",
        "px-3 py-2 rounded shadow-none w-full",
        "outline-none focus:outline-none focus:ring ring-primary ring-opacity-40",
        !disabled && "hover:border-primary hover:ring transition-all",
        error ? "border-red-500" : "",
        className
      )}
      {...props}
    />
  );
};

export default CurrencyInput;
